import { FirestorePicklistCollection, PicklistEntry } from '@/models/picklist';
import { FirestoreService } from '@/services/data/firebase/db/firestoreService';
import { Unsubscribe } from '@/services/data/firebase/db/iFirestoreService';
import { picklistFormatToArray } from '@/services/utils/Utils';
import { Deferred } from '@/core/helpers/deferredPromise';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useService } from '@/composables/useServices';

export const PicklistStore = defineStore('picklist', () => {
  const picklists = ref<Record<string, PicklistEntry[]>>({});
  const unsubscribe = ref<Unsubscribe | undefined>(undefined);
  const subscribers = ref<string[]>([]);

  const firestoreService = useService(FirestoreService);

  const getPicklist = computed(() => (id: string) => picklists.value[id] || []);

  const initializePicklists = async () => {
    if (unsubscribe.value) return;

    const deferred = Deferred.promise();

    unsubscribe.value = firestoreService.subscribeToCollection('picklistsNew2', (allPicklists: FirestorePicklistCollection[]) => {
      allPicklists.forEach((picklist) => {
        picklists.value[picklist.id] = picklistFormatToArray(picklist.elements);
      });
      deferred.resolve();
    });

    return deferred.promise;
  };

  const dispose = () => {
    if (unsubscribe.value) {
      unsubscribe.value();
      unsubscribe.value = undefined;
    }
  };

  return {
    picklists,
    subscribers,
    getPicklist,
    initializePicklists,
    dispose,
  };
});
